import {
  Stack,
  Dialog,
  Typography,
  IconButton,
  DialogTitle,
  DialogContent
} from "@material-ui/core";
import { Close } from "@material-ui/icons";
import { useTranslation } from "react-i18next";
import { WatermarkRemovalStudio } from "./WatermarkRemovalStudio";

type WatermarkRemovalDialogProps = {
  open: boolean;
  listingId: string;
  onClose: () => void;
};

/**
 * Standalone dialog around WatermarkRemovalStudio, so watermark removal is reachable
 * with one click from listing cards / menus (not only via the listing-details tab).
 */
export function WatermarkRemovalDialog({
  open,
  listingId,
  onClose
}: WatermarkRemovalDialogProps): JSX.Element {
  const { t: translate } = useTranslation();

  return (
    <Dialog
      maxWidth="md"
      fullWidth
      open={open}
      onClose={onClose}
      // Contain clicks on the dialog CONTENT so they don't bubble (through the
      // portal's React tree) into the clickable listing card/row hosting this
      // dialog. Deliberately on the paper and NOT an `onClick` on the Dialog
      // itself — this MUI version spreads extra props AFTER its internal
      // `onClick: handleBackdropClick`, so a root onClick would override it and
      // break close-on-backdrop-click.
      PaperProps={{ onClick: (e) => e.stopPropagation() }}
    >
      <DialogTitle sx={{ py: 2 }}>
        <Stack direction="row" justifyContent="space-between" alignItems="center">
          <Typography variant="h4">
            {translate("watermarkRemoval.dialogTitle", "הסרת סימני מים")}
          </Typography>
          <IconButton onClick={onClose}>
            <Close />
          </IconButton>
        </Stack>
      </DialogTitle>
      <DialogContent>
        <WatermarkRemovalStudio listingId={listingId} />
      </DialogContent>
    </Dialog>
  );
}

export default WatermarkRemovalDialog;
